import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ProductVarianceTable from '../components/Variance/ProductVarianceTable';
import CustomerVarianceTable from '../components/Variance/CustomerVarianceTable';

const { FiTrendingUp, FiPackage, FiUsers } = FiIcons;

const VarianceAnalysis = () => {
  const [activeTab, setActiveTab] = useState('product');

  const tabs = [
    { id: 'product', label: 'Product Wise Variance Report', icon: FiPackage },
    { id: 'customer', label: 'Customer Wise Variance Report', icon: FiUsers },
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Variance Analysis</h1>
          <p className="text-gray-500 mt-1">Detailed analysis of Budget vs Forecast vs Actuals</p>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-500">Last updated:</span>
          <span className="text-sm font-medium text-gray-900">Today, 09:30 AM</span>
        </div>
      </div>

      {/* Tabs */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-1.5 flex gap-2 w-full md:w-fit">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 md:flex-none flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                isActive
                  ? 'bg-blue-50 text-blue-700 shadow-sm'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <SafeIcon icon={tab.icon} className={isActive ? 'text-blue-600' : 'text-gray-400'} />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Content */}
      <motion.div
        key={activeTab}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {activeTab === 'product' ? (
          <ProductVarianceTable />
        ) : (
          <CustomerVarianceTable />
        )}
      </motion.div>
    </div>
  );
};

export default VarianceAnalysis;